import React, { useMemo } from 'react';
import SubmitRFQPageStore, { PageStoreContext } from 'store/pages/rfq/initiate-rfq/submit-rfq/pageStore';
import SubmitRFQContent from 'components/rfq/initiate-rfq/submit-rfq';
import RFQStatusLayout from 'components/common/rfq/RFQStatusLayout';

const SubmitRFQPage = (): JSX.Element => {
  const pageStore = useMemo(() => new SubmitRFQPageStore(), []);

  return (
    <RFQStatusLayout>
      <PageStoreContext.Provider value={pageStore}>
        <SubmitRFQContent />
      </PageStoreContext.Provider>
    </RFQStatusLayout>
  );
};

export default SubmitRFQPage;
